import React, { useEffect, useState } from 'react';
import '../chat/Userstyle.css';
import chatbotIcon from '../chat/images/chatbox-icon.svg';
import chatsupportIcon from '../chat/images/chatbot (1).png';
import { useParams } from 'react-router';
import { endpoint } from '../../../resource/Constant';
import { Backdrop, CircularProgress } from '@mui/material';

//To store the message from user and chatbot both
const message = [];
export const UserChatApp = () => {
  //using useState to open and close the chatbot and get the input value
  const [isOpen, SetIsOpen] = useState(false);
  const [input, setInput] = useState('');
  const [tokensused, setTokensLeft] = useState(0);
  const params = useParams();
  const token = params.token;
  const useremail = params.useremail;
  const spring_token = params.jwt;

  useEffect(() => {}, []);
  //sendMessage function to call the api and get the response
  const sendMessage = async () => {
    const chatbox = document.querySelector('.chatbox__support');
    const varfield = document.querySelector('input');
    //try and catch block to catch any unidentified error
    try {
      // Fetching the response from the server
      const response = await fetch(`${endpoint}/api/aichatbot`, {
        method: 'POST', // method of endpoint
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        mode: 'cors', // for cross origin
        body: JSON.stringify({
          message: input,
          user_email: useremail,
          springboot_token: spring_token
        })
      });

      if (!response.ok) {
        message.pop();
        message.push('Sorry, I am not able to connect to the server. Please try again later.');
        updatChattext(chatbox);
        throw new Error(`Http error! statuds ${response.status}`);
      }

      // Extracting the json from the response
      const json = await response.json();
      // getting response based on given by ai or admin
      if (json.message.result) {
        message.pop();
        message.push(json.message.result);
      } else {
        message.pop();
        message.push(json.message);
      }

      updatChattext(chatbox);
      varfield.value = '';
    } catch (error) {
      // Catching the error
      updatChattext(chatbox);
      varfield.value = '';
    }
  };

  //handlesendmessage function to handle the send button and called the sendMessage function
  const handleSendMessage = () => {
    const chatbox = document.querySelector('.chatbox__support');
    let varfield = chatbox.querySelector('input');

    if (varfield.value === '') {
      varfield.placeholder = 'Please enter a message';
      return;
    }
    let user = {
      // information of user
      name: 'User',
      message: input
    };
    message.push(user);
    message.push('Typing'); // loader until getting response
    varfield.value = '';
    updatChattext(chatbox);
    sendMessage();
  };

  //updatechattext to update the dom of the chatbot in the reverse order to show the
  //current message at the last
  const updatChattext = (chatbox) => {
    var html = '';
    message
      .slice()
      .reverse()
      .map((msg) => {
        // using the js map function to traverse in reverse order to get the latest message
        if (msg === 'Typing') {
          html += `<div style="font-weight: 600;">
            <span id="loading" class="typing-dots"><span class="dots"></span></span>
            </div>`;
          // html += `<div id="loading"></div>`;
        } else if (msg.name === 'User') {
          html += '<div class="messages__item messages__item--operator">' + msg.message + '</div>';
        } else {
          html += '<div class="messages__item messages__item--visitor">' + msg + '</div>';
        }
      });
    const chatmessage = chatbox.querySelector('.chatbox__messages');
    chatmessage.innerHTML = html;
  };

  //toggleChatbot function to open and close the chatbot
  const togglechatbot = () => {
    SetIsOpen((prev) => {
      return !prev;
    });
  };
  useEffect(() => {
    const chatbox = document.querySelector('.chatbox__support');
    if (isOpen) {
      chatbox.classList.add('chatbox--active');
    } else {
      chatbox.classList.remove('chatbox--active');
    }
  }, [isOpen]);

  return (
    <>
      <div className="chatbot">
        <div className="chatbox">
          {/* Chatbox content */}
          <div className="chatbox__support">
            <div className="chatbox__header">
              <div className="chatbox__image--header">
                <img style={{ width: '35px', height: '35px' }} src={chatsupportIcon} alt="Chat Icon" />
              </div>
              <div className="chatbox__content--header">
                <h4 className="chatbox__heading--header">DataDrivenAI</h4>
              </div>
            </div>
            <div className="chatbox__messages">
              {/* <!-- Example messages --> */}
              <div className="messages__item messages__item--visitor">Hello! How can I help you today?</div>
              <div className="messages__item messages__item--operator">I need assistance with my account.</div>
            </div>
            <div className="chatbox__footer">
              <input
                id="messageField"
                type="text"
                autocomplete="off"
                placeholder="Type your message..."
                value={input}
                onChange={(e) => {
                  setInput(e.target.value);
                }}
              />
              <button className="chatbox__send--footer send__button" onClick={handleSendMessage}>
                Send
              </button>
            </div>
          </div>
          {/* Chatbox toggle button */}
          <div className="chatbox__button">
            <button onClick={togglechatbot}>
              <img src={chatbotIcon} alt="Chat Icon" />
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserChatApp;
